import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appContext", "buttonProps", "isEmbedded", "previewListingId", "slug", "userInfo"];
import { gate } from 'hub-http/gates';
import getLang from 'I18n/utils/getLang';
import { getDataFetchingClientRequestState } from 'marketplace-ui-common/dataFetchingClient/utils/getDataFetchingClientRequestState';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import { DetailsPageContext } from '../context/DetailsPageContext';
import { useListingPreview } from '../hooks/useListingPreview';
import { useTracking } from '../hooks/useTracking';
import { useUnifiedDetails } from '../hooks/useUnifiedDetails';
import { AgentCTAButton } from './AgentCTAButton';
import { AppCTAButton } from './AppCTAButton';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceListingCTAButton(_ref) {
  let {
      appContext,
      buttonProps,
      isEmbedded = false,
      previewListingId,
      slug,
      userInfo
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const published = !!slug && !previewListingId;
  const isPreview = !!previewListingId;

  // TODO: Remove once id is no longer required
  const {
    unifiedDetailsData: unifiedDetailsDataV2,
    unifiedDetailsLoading: unifiedDetailsLoadingV2,
    unifiedDetailsError: unifiedDetailsErrorV2
  } = useUnifiedDetails({
    appContext,
    language: getLang(),
    skip: !slug || isPreview,
    slug: slug || '',
    version: 2
  });
  const {
    unifiedDetailsData: unifiedDetailsDataV3,
    unifiedDetailsLoading: unifiedDetailsLoadingV3,
    unifiedDetailsError: unifiedDetailsErrorV3
  } = useUnifiedDetails({
    appContext,
    language: getLang(),
    skip: !slug || isPreview,
    slug: slug || '',
    version: 3
  });
  const {
    previewData,
    previewLoading,
    previewError
  } = useListingPreview({
    appContext,
    language: getLang(),
    listingId: previewListingId,
    skip: !isPreview
  });

  // TODO: Remove once id is no longer required
  const unifiedDetailsRequestStatusV2 = getDataFetchingClientRequestState(unifiedDetailsErrorV2, unifiedDetailsLoadingV2);
  const unifiedDetailsRequestStatusV3 = getDataFetchingClientRequestState(unifiedDetailsErrorV3, unifiedDetailsLoadingV3);
  const previewRequestStatus = getDataFetchingClientRequestState(previewError, previewLoading);
  const {
    id
  } = previewData || unifiedDetailsDataV2;
  const {
    agentType,
    appSignInConfiguration,
    betaDetails,
    companyName,
    connectionType,
    features,
    installUrl,
    isDashworks,
    isOpsHub,
    listingIcon,
    listingId,
    name,
    productFeatures,
    productType,
    sourceId,
    urlSlug
  } = previewData || unifiedDetailsDataV3;
  const {
    trackInstall,
    trackInteraction
  } = useTracking({
    appContext,
    companyName,
    embed: isEmbedded,
    isPreview,
    listingId,
    slug: urlSlug,
    sourceId,
    type: productType
  });
  let renderedCTAButton = null;
  if (productType === 'AGENT') {
    renderedCTAButton = /*#__PURE__*/_jsx(AgentCTAButton, Object.assign({
      "data-test-id": "cta-button",
      agentType: agentType,
      betaDetails: betaDetails,
      installUrl: installUrl,
      slug: slug || urlSlug,
      sourceId: sourceId
    }, buttonProps, rest));
  }
  if (productType === 'APP') {
    var _userInfo$gates;
    renderedCTAButton = /*#__PURE__*/_jsx(AppCTAButton, Object.assign({
      "data-test-id": "cta-button",
      appSignInConfiguration: appSignInConfiguration,
      connectionType: connectionType,
      features: features,
      installUrl: installUrl,
      isDashworks: isDashworks,
      isOpsHub: isOpsHub,
      isUngatedForSecureInstallFlow: userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('Marketplace:Apps:SecureInstall')),
      previewListingId: previewListingId,
      productFeatures: productFeatures,
      slug: slug || urlSlug,
      sourceId: sourceId
    }, buttonProps, rest));
  }
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    requestStatus: [unifiedDetailsRequestStatusV2, unifiedDetailsRequestStatusV3, previewRequestStatus],
    children: /*#__PURE__*/_jsx(DetailsPageContext.Provider, {
      value: {
        appContext,
        iconUrl: listingIcon === null || listingIcon === void 0 ? void 0 : listingIcon.value,
        isEmbedded,
        listingId,
        // TODO: Remove once id is no longer required
        listingIdV2: id,
        name,
        productType,
        published,
        runLeadGen: () => {},
        trackInstall,
        trackInteraction,
        userInfo
      },
      children: renderedCTAButton
    })
  });
}